import { render, staticRenderFns } from "./StorePanel.vue?vue&type=template&id=2a4f9983&scoped=true&"
import script from "./StorePanel.vue?vue&type=script&lang=ts&"
export * from "./StorePanel.vue?vue&type=script&lang=ts&"
import style0 from "./StorePanel.vue?vue&type=style&index=0&id=2a4f9983&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f9983",
  null
  
)

export default component.exports